<template>
    <Layout>
        <PageHeader :items="items" :title="title"/>
        <loader :active="loading"/>

        <div class="checkout-tabs">
            <b-tabs pills vertical nav-class="p-0" nav-wrapper-class="col-lg-2 w-100">
                <b-tab v-for="(count, zoneName, index) in zones" :key="zoneName" :active="index === 0" @click="tabChanged(zoneName)">
                    <template v-slot:title>
                        <div class="py-3">Strefa <br> <h4>{{ zoneName }}</h4></div>
                    </template>

                    <div class="row" v-if="currZone === zoneName && !loadingZone">
                        <div v-for="clan in channels" :key="clan.id" class="col-xl-3">
                            <div class="card">
                                <div class="card-header d-flex justify-content-between align-items-center">
                                    <server-group :group="clan.group" withName/>
                                    <span>{{ clan.zoneName }}</span>
                                </div>
                                <div class="card-body d-flex justify-content-center flex-column align-items-center">
                                    <h5 class="mb-3">Właściciel</h5>
                                    <client :client="clan.owner" withAvatar/>

                                    <h5 class="mt-4">Osób online</h5>
                                    <h5>{{ clan.online}} / {{ clan.all }}</h5>

                                    <button class="mt-3 btn btn-primary" @click="() => $router.push({name: 'server.clans.single', params: {id: clan.id}})">
                                        <i class="fa fa-eye"></i> Zobacz więcej
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row" v-else>
                        <div class="col-md-12 pt-5 mt-5">
                            <loader :active="loadingZone"/>
                        </div>
                    </div>
                </b-tab>
            </b-tabs>
        </div>
    </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import ClansService from "@/services/clans.service";

/**
 * Starter component
 */
export default {
    name: "Clans",
    components: {Layout, PageHeader},
    data() {
        return {
            title: "Klany",
            items: [
                {
                    text: "Serwer",
                    href: "/"
                },
                {
                    text: "Klany",
                    active: true
                }
            ],
            loading: true,
            loadingZone: true,
            zones: {},
            channels: [],
            currZone: ""
        };
    },
    mounted() {
        this.loadData();
    },
    methods: {
        loadData() {
            this.loading = true;

            ClansService.getAll().then(
                response => {
                    this.zones = response.data;
                    this.loading = false;
                    this.getZone(Object.keys(this.zones)[0]);
                },
                error => {
                    console.log(error);
                    this.loading = false;
                }
            )
        },
        tabChanged(zoneName) {
            this.getZone(zoneName);
        },
        getZone(name) {
            this.currZone = name;
            this.loadingZone = true;

            ClansService.getZone(name).then(
                response => {
                    this.channels = response.data;
                    this.loadingZone = false;
                },
                error => {
                    console.log(error);
                    this.loadingZone = false;
                }
            );
        }
    }
};
</script>